import { endpoints } from '@/api/endpoints';
import {
  getIdProtectResponseSchema,
  getPaymentProtectionInsuranceResponseSchema,
} from '@/api/SE/addonProducts/schemas';
import { apiRequest } from '@/api/utils/api';

export const getIdProtect = () =>
  apiRequest({
    url: endpoints.SE.addonProducts.idProtect,
    method: 'GET',
    schema: getIdProtectResponseSchema,
  });

export const getPaymentProtectionInsurance = () =>
  apiRequest({
    url: endpoints.SE.addonProducts.paymentProtectionInsurance,
    method: 'GET',
    schema: getPaymentProtectionInsuranceResponseSchema,
  });
